module.exports = __webpack_public_path__ + "static/img/installed-capacity.e7c4a7b1.png";